import { render, staticRenderFns } from "./SaleProductTable.vue?vue&type=template&id=d0c30be2"
import script from "./SaleProductTable.vue?vue&type=script&lang=js"
export * from "./SaleProductTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports